const colors = {
  common: {
    white: '#ffffff',
    orange: '#F67239',
    black: '#000000',
    red: '#ef4444' // تم تعديل الأحمر ليكون أهدأ وأكثر عصرية من الأحمر الصارخ
  },
  
  primary: { // أزرق حيوي وحديث (Vibrant Blue)
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6', // اللون الأساسي (أفتح قليلاً وأكثر إشراقاً)
    600: '#2563eb', // ممتاز لحالة الـ Hover
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
  },

  secondary: { // فيروزي عميق وأنيق (Rich Teal)
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6', // اللون الأساسي الثانوي
    600: '#0d9488', 
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
  },

  grey: { 
    50: "#f8fafc", // تفتيح درجة 50 لتكون خلفية بيضاء مريحة جداً
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a", // تغميق درجة 900 لخلفية الوضع الليلي لتكون احترافية
  },

  error: { 
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444", // أحمر تحذيري قياسي ومريح
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
  },
};

export default colors;